import { render, staticRenderFns } from "./productivity-a45.vue?vue&type=template&id=29c6f4c3"
import script from "./productivity-a45.vue?vue&type=script&lang=js"
export * from "./productivity-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports